export default __webpack_public_path__ + "static/media/Group_11644.9fd8a5da.svg";